import styled, { keyframes } from 'styled-components';
import { color } from 'constants/styled-theme';
import { Success } from './success';
import { Fail } from './fail';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const Container = styled.div`
  animation: ${fadeIn} 0.3s;
  position: fixed;
  top: 0;
  z-index: 10;
  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(6px);
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  @media (max-width: ${p => p.theme.mobile}) {
    top: 60px;
  }
`;

export const InnerContainer = styled.div`
  text-align: center;
  position: relative;
  box-shadow: ${p => p.theme.basicShadow};
  border-radius: 2px;
  background: ${color('gray0')};
  min-width: 300px;
  max-width: 800px;
  min-height: 100px;
  padding: 20px;
  margin: 10px;
  font-weight: ${props => props.theme.fonts.medium};
  max-height: 95vh;
  z-index: 10;
  @media (max-width: ${p => p.theme.mobile}) {
    overflow: auto;
    width: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export { Success, Fail };
